var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.0487L18.875 5.075H12.5C10.25 5.075 8 5.1425 5.875 5.31125C5 5.37875 4.3125 6.0875 4.25 7.0325C4.125 8.45 4.0625 10.2388 4.0625 11.9938V12.9725C4.0625 14.7612 4.125 16.5163 4.25 17.9338C4.34375 18.845 5.03125 19.5875 5.875 19.6213C10.2861 19.9588 14.7139 19.9588 19.125 19.6213C19.9688 19.5875 20.6875 18.845 20.75 17.9338C20.8438 16.5838 20.9063 14.93 20.9375 13.2425L25 9.4625V13.2425C25 15.0313 24.9375 16.82 24.8125 18.2712C24.698 19.7688 24.0891 21.172 23.0967 22.2252C22.1044 23.2783 20.7946 23.9113 19.4062 24.0087C17.1875 24.2112 14.8438 24.3125 12.5 24.3125C10.1562 24.3125 7.8125 24.2112 5.59375 24.0425C4.20537 23.9451 2.89563 23.3121 1.90326 22.2589C0.910889 21.2057 0.301972 19.8025 0.1875 18.305C0.0625 16.7863 0 14.8962 0 13.0062V12.0275C0 10.1375 0.0625 8.2475 0.1875 6.695C0.301972 5.19748 0.910889 3.79425 1.90326 2.74108C2.89563 1.6879 4.20537 1.05492 5.59375 0.9575C7.8125 0.78875 10.1562 0.6875 12.5 0.6875H25V5.075L12.5 16.7863L6.65625 11.3187L9.71875 8.45L12.5 11.0487Z",
    fill: "url(#paint0_linear_9481_1083)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9481_1083",
    x1: 0,
    y1: 12.5,
    x2: 25,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6700FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/HelpIcon.e50e1114a18c015f539add6661b42a79.svg";
export { ForwardRef as ReactComponent };